export class OptionForSynthese {

    IncludeProcess: boolean
    IncludeMC: boolean
    IncludeMEST: boolean
    IncludeMateriaux: boolean
}